import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    width: '100%',
    position: 'relative'
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  textField: {
    '& .MuiInputBase-root': {
      height: '32px',
      margin: '16px 0px 0px',
      backgroundColor: 'transparent',
      '& .MuiInputBase-input': {
        padding: '0px 8px',
        border: 'none',
        backgroundColor: 'transparent',
        color: capitalDesignTokens.semanticColors.foreground.primary
      }
    }
  }
});
